import { type SVGProps } from 'react'

/**
 * Martini icon - represents the app brand.
 * Uses currentColor for flexible styling via className or style.
 *
 * @example
 * // Inherit text color
 * <MartiniIcon className="w-4 h-4" />
 *
 * // Custom color
 * <MartiniIcon className="w-4 h-4 text-muted-foreground" />
 */
export function MartiniIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* Glass */}
      <path d="M8 2h8l-1 8H9l-1-8Z" />
      {/* Stem */}
      <line x1="12" y1="10" x2="12" y2="20" />
      {/* Base */}
      <line x1="8" y1="20" x2="16" y2="20" />
      {/* Olive */}
      <circle cx="10" cy="6" r="1" fill="currentColor" />
    </svg>
  )
}
